import CaseTypeRM from '../responsemodel/CaseTypeRM'
import CaseType from '../../models/CaseType'
import DataMapper from './DataMapper'

export default class CaseTypeDataMapper extends DataMapper<CaseTypeRM, CaseType> {
  map = (rm: CaseTypeRM) => {
    // Extract case category code - it can be a string or an object with code property
    let caseCategoryCode = '';
    if (!rm.caseCategory) {
      caseCategoryCode = '';
    } else if (typeof rm.caseCategory === 'string') {
      caseCategoryCode = rm.caseCategory;
    } else if (typeof rm.caseCategory === 'object') {
      // Handle object format: {code: "LTI", name: "Low TAT Investigation", ...}
      caseCategoryCode = rm.caseCategory.code || '';
    }
    
    return new CaseType(
      rm.id,
      rm.name,
      caseCategoryCode,
      rm.internalTAT,
      rm.investigatorTAT,
      rm.capping,
      rm.services,
      rm.requiredDocuments,
      rm.isActive ?? true
    )
  }
}
